// Paleta de colores compartida por los gráficos de todos los dashboards —
// mismo tono/escala que usa el proyecto hermano mern-consultora
// (client/src/utils/chartConfig.js), anclada en los 3 colores base que ya
// se venían repitiendo sueltos en cada dashboard: #0E376E (oscuro),
// #648EBC (medio) y #A4C4E0 (claro).
export const CHART_PALETTE = [
  "#071A35", // extra oscuro
  "#0E376E", // base oscuro
  "#1A4E8A",
  "#2E65A0",
  "#4278B4",
  "#648EBC", // base medio
  "#7EAAD0",
  "#92BCE0",
  "#A4C4E0", // base claro
  "#B8D4EA",
  "#CCE3F2",
  "#DFF0F9", // muy claro
];

// Paleta corta para comparaciones (ej. barras por año/sitio), igual que
// mern-consultora.
export const BAR_PALETTE = ["#274b72", "#376596", "#0E376E", "#669ece", "#A4C4E0"];
